<template>
  <v-dialog
      v-model="visible"
      no-click-animation
      persistent
      max-width="500"
      content-class="elevation-0"
      overlay-opacity="0.8"
      :retain-focus="false"
      style="z-index: 9999"
  >
    <v-fade-transition>
      <v-card v-if="!isLoading"
              id="modalEvent"
              min-height="300"
              class="mx-auto"
      >
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in popupList" :key="index">
            <v-img
                :src="popupImageUrl(item)"
                aspect-ratio="1"
                width="500"
                @click="onImageLink(item)"
            />
          </swiper-slide>
          <div v-if="popupList.length > 1" class="swiper-pagination modal-event-pagination" slot="pagination"></div>
        </swiper>
        <v-card-actions class="pa-0">
          <v-row no-gutters>
            <v-col>
              <v-btn block plain class="rounded-0" @click="onModalEventClose(true)">오늘은 그만 보기</v-btn>
            </v-col>
            <v-col>
              <v-btn block plain class="rounded-0"
                     style="border-left: 1px solid #ccc"
                     @click="onModalEventClose()">닫기</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-fade-transition>
    <v-progress-circular v-if="isLoading" indeterminate class="pos-center" color="white" />
  </v-dialog>
</template>

<script>
import { swiper, swiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import store from "@/store";
import VueCookies from "vue-cookies";
import {mixinAuth} from "@/mixins";
import moment from "moment";

export default {
  name: 'ModalEvent',
  components: {
    swiper, swiperSlide
  },
  directives: {
    swiper: directive,
  },
  mixins: [mixinAuth],
  data: () => ({
    visible: false,
    isLoading: true,
    popupList: [],
    cookie: 'popupCookie',
    swiperOption: {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: false
      }
    },
    oldOrdDtl:null
  }),
  created () {
  },
  mounted() {
    if (this.cookie != null && this.cookie != '') {
      if (VueCookies.isKey(this.cookie)) {
        this.isLoading = false
        this.visible = false
      } else {
        if (this.isSamsungFire) {
          this.initAnyfitPro();
          // TODO. ..&.
          this.showSamsungFireSurvey().then(bool=> {
            this.getUserPopupList(bool)
          });
        } else {
          this.getUserPopupList()
        }
      }
    }
  },
  methods: {
    popupImageUrl(item) {
      return item.writeChannelCode === "DEVELOPER" ? this.getImage('survey20231023.png') : this.$downUrl(item.imageName)
    },
    // TODO 삼성화재 애니핏 프로 script 추가
    initAnyfitPro() {
      let anyfitproScript = document.createElement('script')
      anyfitproScript.setAttribute('src', 'https://anyfitpro.samsungfire.com/apps/common/js/anyfit_appinterface_min.js')
      document.head.appendChild(anyfitproScript)
    },
    // TODO 삼성화재 설문 개별페이지 작업 전 까지 사용 예정 (추후 삭제)
    async showSamsungFireSurvey() {
      return await store.dispatch('getLastOrdDtl')
        .then(res => {
          if (res.success) {
            this.oldOrdDtl = res.data
            if (this.oldOrdDtl !== null) {
              if (this.isSamsungFireSurveyDateInRange(this.oldOrdDtl.usePeriodEndDt)
                    && this.oldOrdDtl.surveyAnswerState === 'N') {
                return true
              }

              if (store.getters.useOrdDtl.travelYn === 'Y'
                    && this.isSamsungFireSurveyDateInRange(store.getters.useOrdDtl.usePeriodEndDt)
                    && this.oldOrdDtl.surveyAnswerState === 'N') {
                return true
              }
            }
          }
          return false;
        }).finally(()=>{})

    },
    isSamsungFireSurveyDateInRange(usePeriodEndDt) { // 삼성화재용 만족도 평가 기간 ( 티켓 종료일 기준 > D-3 ~ D+7 노출)
      const endDt = moment(usePeriodEndDt) // 티켓 종료일
      const threeDaysAgo = endDt.clone().subtract(3, 'days') // D-3일 계산
      const thirtyDaysLater = endDt.clone().add(30, 'days') // D+30일 계산
      const currentMoment = moment() // 현재 날짜

      return currentMoment.isBetween(threeDaysAgo, thirtyDaysLater, null, '[]')
    },
    async getUserPopupList (all = true) {
      this.visible = false
      await store.dispatch('getUserPopupList')
          .then(res => {
            if (res.success && res.data.length > 0) {
              this.popupList = all
                  ? res.data
                  : res.data.filter(item => item.writeChannelCode !== "DEVELOPER") //삼성화재 서베이 컨텐츠 개발자등록

              if (this.popupList.length > 0) this.visible = true
            }
          }).catch(() => {
            this.visible = false
          }).finally(() => {
            this.isLoading = false
          });
    },
    onModalEventClose (todayClose = false) {
      if (todayClose) {
        if(this.cookie != null && this.cookie != ''){
          VueCookies.set(this.cookie,this.cookie,'1d');
        }
      }
      this.visible = false
    },
    async onImageLink (value) {
      if (value.targetUrl !== null && value.targetUrl !== ''
          && value.linkTypeCode !== null && value.linkTypeCode !== '' && value.linkTypeCode !== 'NONE') {
        await store.dispatch('updatePopupCnt', this.$_payload({'popupId': value.popupId}, null))
            .then(res => {
              if(res.success) {
                if (value.linkTypeCode === 'EXTERNAL') { // 외부 링크
                  window.open(value.targetUrl)
                } else if (value.linkTypeCode === 'INTERNAL') { // 내부 링크
                  this.movePage(value.targetUrl)
                }
              } else {
                console.log(res)
              }
            }).catch(error => {
              console.log(error);
            })
      }
    },
    // // TODO 삼성화재 만족도 조사 링크 호출부
    // openSfLink () {
    //   this.$router.push({name: '만족도조사'})
    // }
  }
}
</script>

<style lang="scss">
  .modal-event-pagination {
    //left: 50%;
    //bottom: 0;
    //transform: translateX(-50%);
    //height: 25px;
    .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      margin: 0 3px;
      background-color: var(--v-primary-base);
      box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.7 );
      &:not([class*="active"]) {
        background-color: #fff;
        opacity: 1;
      }
    }
  }
</style>
